// extracted by css-extract-rspack-plugin
export default {"valueFields":"QAkpLXAzZNsBYmCT__valueFields___"};